module.exports = __webpack_public_path__ + "img/Group 647three.b432f536.png";